module.exports = __webpack_public_path__ + "static/media/welcomeBg.47e50cca.jpg";